import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import type { ReactNode } from 'react';

const PageNotFound = lazy(() => import('@/pages/core/error'));

function RouteErrorFallback() {
    const { t } = useTranslation();
    return (
        <Suspense
            fallback={
                <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center">
                    {t('common.message.record.something_wrong', 'Something went wrong')}
                </div>
            }
        >
            <PageNotFound
                status="500"
                title={t('common.message.record.something_wrong', 'Something went wrong')}
                subTitle={t(
                    'common.message.record.please_try_reloading',
                    'Please try reloading the page.',
                )}
                showReloadButton
            />
        </Suspense>
    );
}

interface RouteErrorBoundaryProps {
    children: ReactNode;
    resetKeys?: unknown[];
}

export function RouteErrorBoundary({ children, resetKeys }: RouteErrorBoundaryProps) {
    return (
        <ErrorBoundary
            FallbackComponent={RouteErrorFallback}
            resetKeys={resetKeys}
            onError={(error, info) => {
                console.error('Route render error:', error, info.componentStack);
            }}
        >
            {children}
        </ErrorBoundary>
    );
}
